import { render, staticRenderFns } from "./ErgebnisCard.vue?vue&type=template&id=1ea0921e&"
import script from "./ErgebnisCard.vue?vue&type=script&lang=js&"
export * from "./ErgebnisCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports